import config from "@/config"
import http from "@/utils/request"

export default {
	listApiLogs: {
		url: `${config.API_URL}/lqa-game/system/apiLogs/list`,
		name: "TAPD调用日志",
		get: async function (params) {
			return await http.get(this.url, params);
		}
	},
	getApiLogs: {
		url: `${config.API_URL}/lqa-game//system/apiLogs`,
		name: "TAPD调用日志",
		get: async function (params) {
			return await http.get(this.url + params);
		}
	},
	addApiLogs: {
		url: `${config.API_URL}/lqa-game/system/apiLogs`,
		name: "TAPD调用日志",
		post: async function (data) {
			return await http.post(this.url, data);
		}
	},
	updateApiLogs: {
		url: `${config.API_URL}/lqa-game/system/apiLogs`,
		name: "TAPD调用日志",
		put: async function (data) {
			return await http.put(this.url, data);
		}
	},
	delApiLogs: {
		url: `${config.API_URL}/lqa-game/system/apiLogs`,
		name: "删除双语文件信息",
		delete: async function (id) {
			return await http.delete(this.url + id);
		}
	},
	dealJobNow:{
		url: `${config.API_URL}/lqa-game/system/apiLogs/dealJob`,
		name: "TAPD调用日志",
		get: async function (params) {
			return await http.get(this.url +"?parma="+params);
		}
	}

}
